import { EffectMap } from '~/client/src/shared/stores/EventStore/BaseEvents.store'
import EffectsProcessor from '~/client/src/shared/stores/EventStore/EffectsProcessors/EffectsProcessor'
import EventsStore from '~/client/src/shared/stores/EventStore/Events.store'
import EventTypes from '~/client/src/shared/stores/EventStore/eventTypes'

import MobileInitialState from '../MobileInitialState'

type MobileEventHandler = (
  state: MobileInitialState,
  ...args: any[]
) => void | EffectMap

export default class MobileEventStore extends EventsStore {
  public constructor(
    public effectProcessor: EffectsProcessor,
    public appState: MobileInitialState,
  ) {
    super(effectProcessor, appState)
  }

  public dispatch(type: EventTypes, ...args: any[]) {
    return super.dispatch.call(this, type, ...args)
  }

  public on(type: EventTypes, handler: MobileEventHandler) {
    return super.on.call(this, type, handler)
  }
}
